<style>
  .mat-detail-row {
    padding-left: 55px !important;
  }
</style>
<div style="text-align:center;padding-top:10px" *ngIf="medications.length == 0  && isBusy==false" translate>No
  Medications data exists for student</div>
<div *ngIf="medications.length > 0">
  <mat-table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear matSort matSortActive="Medication"
    matSortDirection="asc" aria-label="Medications Data Table">
    <ng-container matColumnDef="More">
      <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"><span translate>More</span></mat-header-cell>
      <mat-cell *matCellDef="let med" style="min-width:68px;max-width:68px;text-align:center;color:black;">
        <span aria-label="Expand row for more details" *ngIf="ShowRow(med.Pharmacy,med.Phone,med.RxNumber,med.Doctor,'','Child',med.Id)">
          <i [ngClass]="checkExpanded(med) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"></i>
        </span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Medication">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Medication</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="Medication" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let med">{{med.Medication}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Frequency">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Frequency</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="Frequency" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let med">{{med.Frequency}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="StartDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Start Date</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="StartDate" dataType="date"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let med">
        <span *ngIf="med.StartDate != '0001-01-01T00:00:00'">{{med.StartDate|date:'MM/dd/yy'}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="EndDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>End Date</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="EndDate" dataType="date"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let med">
        <span *ngIf="med.EndDate != '0001-01-01T00:00:00'">{{med.EndDate|date:'MM/dd/yy'}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Dose">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Dose</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="Dose" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let med">{{med.Dose}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="SchoolAuthorisedToAdminister">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 160px; max-width: 160px; display: flex; justify-content: center;">
          <span translate>School Authorized<br/>to Administer</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="SchoolAuthorisedToAdminister" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let med" style="min-width: 160px; max-width: 160px; display: flex; justify-content: center;">{{med.SchoolAuthorisedToAdminister}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="expandRow">
      <div mat-cell *matCellDef="let med;let i = index;" style="width:100%;" [attr.colspan]="displayedMedicationColumns.length">
        <div class="mat-detail-card">
          <table>
            <thead>
              <tr style="line-height:normal;">
                <th class="tyl-table-header" style="padding: 5px;width:25%;min-width:250px;" translate>Pharmacy</th>
                <th class="tyl-table-header" style="padding: 5px;width:25%;min-width: 250px;" translate>Phone</th>
                <th class="tyl-table-header" style="padding: 5px;width:25%;min-width: 250px;" translate>Rx Number</th>
                <th class="tyl-table-header" style="padding: 5px;width:25%;min-width: 250px;" translate>Doctor</th>
              </tr>
            </thead>
            <tbody>
              <tr style="min-height:40px;">
                <td class="tyl-table-body" style="padding: 5px;min-width: 250px;width:25%;">{{med.Pharmacy}}</td>
                <td class="tyl-table-body" style="padding: 5px;min-width: 250px;width:25%;">{{med.Phone}}</td>
                <td class="tyl-table-body" style="padding: 5px;min-width: 250px;width:25%;">{{med.RxNumber}}</td>
                <td class="tyl-table-body" style="padding: 5px;min-width: 250px;width:25%;">{{med.Doctor}}</td>
              </tr>
              <tr *ngIf="med.Comments!=null || med.length > 0">
                <td style="line-height:150%;font-size:14px;padding-top:15px;" colspan="4">
                  <b class="tyl-table-header" style="padding: 5px;font-size:14px;" translate>Comments</b><br />
                  <p style="white-space:pre-wrap;font-size:14px;padding: 5px">{{med.Comments}}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- Row definitions -->
    <mat-header-row *matHeaderRowDef="displayedMedicationColumns"></mat-header-row>
    <mat-row *matRowDef="let row;let i= index; columns: displayedMedicationColumns;" (click)="toggleExpanded(row)"
      (keydown)="rowKeyPress($event, row)" [attr.aria-label]="getMedicationAriaRow(row)"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandRow']" [@detailExpand]="checkExpanded(row) && ShowRow(row.Pharmacy,row.Phone,row.RxNumber,row.Doctor,'','Child',row.Id) ? 'expanded' : 'collapsed'"
      style="overflow: hidden" class="mat-detail-row"></mat-row>
  </mat-table>
</div>